<div class="update-limit-popup-backdrop" (click)="close()"></div>
<div class="update-limit-popup" role="dialog" aria-modal="true" aria-label="Update limit" tabindex="-1" cdkTrapFocus
     (keydown.escape)="onEscape($event)">
  <div class="update-limit-popup-header">
    <i class="material-icons-outlined notranslate update-limit-popup-icon">speed</i>
    <span class="update-limit-popup-title">Update limit</span>
    <div class="update-limit-popup-header-actions">
      <button class="update-limit-popup-action-btn update-limit-popup-action-btn--close"
              matTooltip="Close"
              matTooltipPosition="below"
              [matTooltipShowDelay]="500"
              type="button"
              aria-label="Close popup"
              (click)="close()">
        <i class="material-icons-outlined notranslate">close</i>
      </button>
    </div>
  </div>

  <div class="update-limit-popup-body">
    <div class="update-limit-popup-sentence">
      Stop after updating
      <div class="update-limit-field"
           matAutocompleteOrigin
           #fieldOrigin="matAutocompleteOrigin"
           matTooltip="Pick a suggested limit or type any whole number. Leave blank for no limit."
           matTooltipPosition="above"
           [matTooltipShowDelay]="500">
        <input #limitInput
               class="update-limit-input"
               type="text"
               inputmode="numeric"
               maxlength="15"
               autocomplete="off"
               placeholder="No limit"
               aria-label="Maximum records updated per run"
               [formControl]="fieldControl"
               #suggestionsTrigger="matAutocompleteTrigger"
               [matAutocomplete]="suggestionsPanel"
               [matAutocompleteConnectedTo]="fieldOrigin"
               (focus)="onFocus()"
               (blur)="onBlur()"
               (beforeinput)="onBeforeInput($any($event))"
               (keydown.enter)="$event.preventDefault()" />
        <button class="update-limit-arrow"
                type="button"
                tabindex="-1"
                aria-label="Show suggested limits"
                [class.update-limit-arrow--open]="suggestionsTrigger.panelOpen"
                (mousedown)="$event.preventDefault()"
                (click)="togglePanel()">
          <svg viewBox="0 0 24 24" width="24" height="24" focusable="false" aria-hidden="true"><path d="M7 10l5 5 5-5z"></path></svg>
        </button>
      </div>
      records per run
    </div>

    <div class="message tip kyloe-message">
      <i class="material-icons-outlined notranslate">info</i>
      <div>
        Records already up to date don't count. Leave blank for no limit.
        @if (control.value) {
          Preview will still show the full total, but only <strong>{{ control.value | number }}</strong> will be updated.
        }
      </div>
    </div>
  </div>

  <section class="footer-btns update-limit-popup-footer">
    @if (control.value) {
      <button mat-button type="button" class="danger-btn-hover" (click)="removeLimit()">REMOVE LIMIT</button>
    }
    <button mat-button type="button" (click)="close()">DONE</button>
  </section>
</div>

<mat-autocomplete #suggestionsPanel="matAutocomplete" class="update-limit-panel"
                  (optionSelected)="onSuggestionSelected()">
  @for (suggestion of suggestions; track suggestion.value) {
    <mat-option [value]="suggestion.value">
      <span [class.update-limit-muted]="!suggestion.value">{{ suggestion.label }}</span>
    </mat-option>
  }
</mat-autocomplete>
